<template>
    <div>
        <pxkeji-rightHeader/>

        <div class="pxkeji-right-box">
            <a-form class="ant-advanced-search-form">
                <a-row :gutter="24">
                    <a-col :span="6">
                        <a-form-item label="申请时间">
                            <a-range-picker
                                    format="YYYY-MM-DD"
                                    :placeholder="['开始时间', '结束时间']"
                                    @change="onTimeChange"
                            />
                        </a-form-item>
                    </a-col>

                    <a-col :span="4" style="margin-top:5px;">
                        <a-button type="primary" @click="searchList" v-btnlimit="'联系我们-搜索'">搜索</a-button>
                    </a-col>
                </a-row>
            </a-form>
        </div>

        <div class="pxkeji-right-box">
            <a-table
                    :columns="list.columns"
                    rowKey="id"
                    :pagination="false"
                    :dataSource="list.datas"
                    :loading="isloading"
                    :locale="{emptyText:'暂无数据'}"
            >

                <!--                :pagination="list.pagination"-->
                <!--                                   @change="onChange"-->

                <span slot="method" slot-scope="method">
                          <span v-if="method==1">市场合作</span>
                          <span v-else-if="method==2">课程合作</span>
                          <span v-else-if="method==3">平台合作</span>
                          <span v-else-if="method==4">院校合作</span>
                          <span v-else-if="method==5">全面合作</span>
                        </span>
                <span slot="status" slot-scope="status">
                          <span v-if="status==0">未处理</span>
                          <span v-else>已处理</span>
                        </span>
                <span slot="action" slot-scope="info">
                          <a-button v-if="info.status==0" name="处理" size="small" @click="changeStatus(info.id)"
                                    type="primary"  v-btnlimit="'联系我们-处理'">处理</a-button>
                        </span>
            </a-table>
<!--            //v-model="list.pagination.current"-->
            <a-pagination

                    :total="list.pagination.total"
                    :show-total="total => `共 ${total} 条`"
                    @change="onShowSizeChange"
                    :page-size="list.pagination.defaultPageSize"
                    :default-current="list.pagination.current"
            />
        </div>


    </div>
</template>
<script>
    var that;


    const columns = [
        {
            dataIndex: "id",
            key: "id",
            align: "center",
            title: "序号",
        },
        {
            dataIndex: "name",
            key: "name",
            align: "center",
            title: "姓名",
        },

        {
            dataIndex: "method",
            key: "method",
            align: "center",
            title: "合作方式",
            scopedSlots: { customRender: "method" },

        },
        //
        {
            dataIndex: "company",
            key: "company",
            align: "center",
            title: "公司",
        },
        {
            dataIndex: "phone",
            key: "phone",
            align: "center",
            title: "电话",
        },
        // {
        //     dataIndex: "email",
        //     key: "email",
        //     align: "center",
        //     title: "收票邮箱",
        //
        // },
        {
            dataIndex: "createtime",
            key: "createtime",
            align: "center",
            title: "申请时间",

        },
        // {
        //     dataIndex: "telephone",
        //     key: "telephone",
        //     align: "center",
        //     title: "电话",
        //
        // },
        // {
        //     dataIndex: "companyName",
        //     key: "companyName",
        //     align: "center",
        //     title: "公司名称",
        //
        // },
        // {
        //     dataIndex: "taxNo",
        //     key: "taxNo",
        //     align: "center",
        //     title: "纳税人识别号",
        //
        // },
        {
            dataIndex: "status",
            key: "status",
            align: "center",
            title: "状态",
            scopedSlots: { customRender: "status" },

        },
        {
            title: "操作",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "action" },
        },

    ];

    export default {
        name: "contactlist",
        data() {
            return {
                list: {
                    columns, //表头
                    datas: [], //数据
                    pagination: {
                        //分页器
                        showQuickJumper: true,
                        hideOnSinglePage: true,
                        total: 0,
                        current: 1, //页码
                        defaultPageSize: 10, //页容
                    },
                },
                where: {
                    //查询条件
                    keyword: {
                        //搜索条件

                        startTime: "",
                        endTime: "",
                    },
                },
                selectRows: [], //选中项编号
                isloading: false,
                visible: false, //弹框

            };
        },
        components: {},
        mounted: function () {
            this.$nextTick(function () {
                that = this;
                this.GetList();
            });
        },
        watch: {},
        methods: {
            onTimeChange(date, dateString) {
                this.where.keyword.startTime = dateString[0];
                this.where.keyword.endTime = dateString[1];
            },
            GetList() {
                this.isloading = true;
                this.$api.form.getFormSubmit(this.list.pagination.current, this.list.pagination.defaultPageSize,
                    this.where.keyword.startTime, this.where.keyword.endTime)
                    .then(res => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            this.list.datas = res.data.records;
                            this.list.pagination.total = Number(res.data.total);
                        } else {
                            this.$message.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });

            },

            searchList() {
                this.list.pagination.current = 1;
                this.GetList();
            },
            onShowSizeChange(current){
                this.list.pagination.current = current;
                this.GetList();
            },
            changeStatus(id){
                var that = this;
                this.$confirm({
                    title: '警告',
                    content: '您确定已经处理该条信息了吗',
                    okText: '确认',
                    cancelText: '取消',
                    onOk() {
                        that.isloading = true;
                        that.$api.form.changeStatus(id).then(res=>{

                            if(res.errorCode != '0000'){
                                that.$message.error(res.errorMsg);
                            }
                            that.isloading = false;
                            that.GetList();
                        }).catch(() => {
                           that.isloading = false;
                       });
                    },
                });


            }

            /*禁用启用 */


        },
    };
</script>

<style>
    .ant-advanced-search-form .ant-form-item {
        display: flex;
    }

    .ant-advanced-search-form .ant-form-item-control-wrapper {
        flex: 1;
    }

    #components-form-demo-advanced-search .ant-form {
        max-width: none;
    }

    #components-form-demo-advanced-search .search-result-list {
        margin-top: 16px;
        border: 1px dashed #e9e9e9;
        border-radius: 6px;
        background-color: #fafafa;
        min-height: 200px;
        text-align: center;
        padding-top: 80px;
    }
</style>

